import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DirectivesModule } from "src/directives/directives.module";
import { SplashScreenComponent } from "./splash-screen";
import { CommonModule } from "@angular/common";

@NgModule({
    declarations: [SplashScreenComponent],
    imports: [
        CommonModule,
        DirectivesModule,
        TranslateModule.forChild(),
    ],
    exports: [SplashScreenComponent],
})
export class SplashScreenModule { }

